import { Module } from "vuex";

import { RootState } from "@/types";

import { ErrorsState } from "./types";
import { mutations } from "./mutations";
import { getters } from "./getters";

export const state: ErrorsState = {
   errors: [],
};

const namespaced: boolean = true

export const errors: Module<ErrorsState, RootState> = {
  namespaced,
  state,
  mutations,
  getters,
};
